module.exports = __webpack_public_path__ + "static/img/1.13afc89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/chale/1.jpg
// module id = QWjV
// module chunks = 1